import { Component } from '@angular/core';

@Component({
  selector: 'ngx-crud-search-ingresoEgreso',
  templateUrl: './crud-search-ingresoEgreso.component.html'
})
export class CrudSearchIngresoEgresoComponent {}